import { jsx as _jsx } from "nativewind/jsx-runtime";
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { Text } from 'react-native';
import styled from 'styled-components/native';
import SccTouchableOpacity from './SccTouchableOpacity';
export default function TabBar({ items, current, onChange, }) {
    return (_jsx(Container, { children: items.map(({ value, label }) => (_jsx(TabButton, { elementName: `${value}_tab_button`, active: current === value, onPress: () => onChange(value), children: _jsx(TabLabel, { active: current === value, children: label }) }, String(value)))) }));
}
const Container = styled.View({
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
});
const TabButton = styled(SccTouchableOpacity)(({ active }) => ({
    flex: 1,
    borderBottomWidth: active ? 2 : 1,
    borderBottomColor: active ? color.brand50 : color.gray20,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 12,
}));
const TabLabel = styled(Text)(({ active }) => ({
    fontSize: 16,
    fontFamily: font.pretendardMedium,
    color: active ? color.gray80 : color.gray40,
}));
